/*---------------------------------------------------------------
 ?? Project: Ring2All Platform
 ????? Author: Rodrigo Cuadra
 ?? Company: Ring2All LLC
 ?? File: hooks\useAiToolProfilesColumns.tsx
 ??? Created: 2026-05-02
 ?? Description:
    Implementation of the AI Integration module.
----------------------------------------------------------------*/


import { useMemo } from 'react';
import { useI18n } from '../../../hooks/useI18n';

export function useAiToolProfilesColumns() {
  const { t, refreshKey, i18n } = useI18n();

  const availableColumns = useMemo(
    () => [
      { key: 'name',        label: t('aiToolProfiles.columns.name'),        visible: true,  sortable: true  },
      { key: 'description', label: t('aiToolProfiles.columns.description'), visible: true,  sortable: false },
      { key: 'toolCount',   label: t('aiToolProfiles.columns.tools'),       visible: true,  sortable: false },
      { key: 'enabled',     label: t('aiToolProfiles.columns.enabled'),     visible: true,  sortable: false,
        render: (v: boolean) => v ? '?' : '?' },
      { key: 'actions',     label: t('aiToolProfiles.columns.actions'),     visible: true,  sortable: false,
        align: 'right' as const },
    ],
    [t, refreshKey, i18n.language]
  );

  return { availableColumns };
}
